import {Component} from '@angular/core';
import { Router } from '@angular/router';
import {AuthenticationService} from "@app/_services";
import { PagesService } from '@app/_services/pages.service';

@Component({
  selector: 'footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['footer.component.scss']
})
export class FooterComponent {
  constructor(public authService: AuthenticationService,
    private router: Router,
    public pagesService: PagesService) {
  }

  get isLoggedIn() {
    return this.authService.isLoggedIn;
  }

  ngOnInit() {
  }

  login() {
    this.authService.popup('login');
  }

    // ngOnInit(){
    //   this.pagesService.root().subscribe(
    //     resp=> this.pagesService.rootPages = resp
    //   )
    // }
  
    get rootPage() {
      return this.pagesService.rootPage;
    }

      openMobileMenu(){
    this.router.navigate([{outlets: {slider: 'pages-menu'}}], {skipLocationChange: true}).then();
  }

}
